var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.placeId)?_c('router-link',{attrs:{"to":_vm.placeRoute}},[_vm._v(_vm._s(_vm.placeName))]):(_vm.placeName)?_c('span',[_vm._v(_vm._s(_vm.placeName))]):_c('span',[_vm._v("Unknown Location")])}
var staticRenderFns = []

export { render, staticRenderFns }